import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Widget, GridView, SimpleView, Table, ColumnProps, FormResetButton, Row, FormInput, Form, Col, Button } from '@digital/ui';
import { PaginationConfig } from 'antd/lib/pagination';
import { Input, Icon } from 'antd';
import { compareText, compareTypeNumber } from '@app/helpers/comparators';
import { getAllPermissoes, Permissoes, updatePermissoe } from '@app/api/moduloPerfilPermissao';

const DefinicaoPermissao = () => {

    const [allPermissoes, setAllPermissoes] = useState<Permissoes[]>();

    const colluns: ColumnProps<Permissoes>[] = [
        {
            title: 'N',
            dataIndex: 'index',
            width: '3%',
            sorter: (a, b) => compareTypeNumber(a.index, b.index),
        },
        {
            title: 'Código',
            dataIndex: 'codigo',
            sorter: (a, b) => compareText(a.codigo, b.codigo),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="codigo"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.codigo !== undefined &&
                record.codigo
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME',
            dataIndex: 'nome',
            sorter: (a, b) => compareText(a.nome, b.nome),
            render: (index, record) => {
                return <>
                    <Input
                        value={record.nome}
                        onChange={(e) => {
                            const novoValor = e.target.value;
                            record.nome = novoValor;
                            record.itemEditado = true;
                            if (allPermissoes) {
                                const itens = allPermissoes.filter((permissao) => {
                                    if (permissao.id === record.id) {
                                        permissao = record;
                                    }
                                    return permissao;
                                });
                                setAllPermissoes(itens);
                            }
                        }}
                        onPressEnter={() => {
                            harUpdate(record);
                        }}
                    />
                </>
            },
            filters: [{ text: 'OCULTAR NA', value: 'ocultar' }],
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            filteredValue: ['ocultar'],
            onFilter: (value, record) => {
                if (value === 'ocultar') {
                    return record.nome.toLowerCase() !== 'na'
                }
                return true
            },
        }
    ]

    const codiguracaoPaginacao = {
        pageSize: 20,
        onChange: (() => {
            document.getElementById("tableResultDefinicaoPermissoes").scrollIntoView();
        })
    } as PaginationConfig;

    const harUpdate = (valores: Permissoes) => {
        updatePermissoe(valores).then((data) => { });
    }

    useEffect(() => {
        getAllPermissoes().then((data) => {
            setAllPermissoes(data);
        });
    }, [])


    return (
        <SimpleView >
            <GridView noform>
                {(true) ? (
                    <Widget
                        title="DEFINIÇÃO DAS PERMISSÕES"
                        span={12}
                        actions={[]}>
                        <Table
                            rowKey="id"
                            key="id"
                            id="tableResultDefinicaoPermissoes"
                            columns={colluns}
                            dataSource={allPermissoes}
                            pagination={codiguracaoPaginacao}
                        />
                    </Widget>
                ) : (<> </>)}
            </GridView>
        </SimpleView>
    );
}
export default DefinicaoPermissao;